import { Injectable, Inject } from '@angular/core';
import { ReservationService } from './reservation.service';
import { HttpClient,HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { Reservation } from '../model/reservation.model';
import { PaymentSessionTokenResponse } from '../model/payment-session-token-response';
import { ReservationPayment } from '../model/reservation-payment';
import { TranslationService } from './translate.service';

@Injectable({
  providedIn: 'root'
})
export class PaymentService {

  constructor(
    private reservationService: ReservationService,
    private httpClient: HttpClient,
    @Inject('BASE_URL') private baseUrl: string,
    private translationService: TranslationService) { }


  pay(reservation: Reservation): Observable<PaymentSessionTokenResponse> {
    return this.httpClient.post<PaymentSessionTokenResponse>(this.baseUrl + '/api/Payment/PaymentInit', reservation );
  }

  getPaymentById(paymentId: string): Observable<ReservationPayment> {
    return this.httpClient.get<ReservationPayment>(this.baseUrl + '/api/Payment/GetPaymentById/' + paymentId);
  }
}
